import { RematchDispatch } from '@rematch/core';
import { axiosErrorHandler } from 'common/helpers';
import { IRootModel } from 'app/store';
import { timerService } from 'entities/Timer/Timer.service';
import { ITimerPayload, ITimerUpdatePayload } from 'entities/Timer/Timer.models';

let timerId: NodeJS.Timer;

export const timerEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async getTimer(eventId: number) {
    dispatch.timer.setLoading(true);

    try {
      const response = await timerService.getTimer(eventId);
      dispatch.timer.setTimer(response);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.timer.setLoading(false);
    }
  },
  async pingTimer(eventId: number) {
    timerId = setInterval(() => {
      timerService.pingTimer(eventId).catch(axiosErrorHandler);
    }, 10000);
  },
  clearPingTimer() {
    clearInterval(timerId);
  },
  async startTimer(payload: ITimerPayload) {
    dispatch.timer.setLoading(true);

    try {
      await timerService.startTimer(payload.eventId);
      dispatch.timer.setIsRunning(true);
      dispatch.timer.pingTimer(payload.eventId);
      dispatch.global.onSuccess(payload);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.timer.setLoading(false);
    }
  },
  async stopTimer(payload: ITimerPayload) {
    dispatch.timer.setLoading(true);

    try {
      const response = await timerService.stopTimer(payload.eventId);
      dispatch.timer.setIsRunning(false);
      dispatch.timer.clearPingTimer();
      dispatch.global.onSuccess(payload);
      dispatch.historyList.getHistory(payload.eventId);
      return response;
    } catch (error) {
      axiosErrorHandler(error);
      return null;
    } finally {
      dispatch.timer.setLoading(false);
    }
  },
  async deleteTimer(payload: ITimerPayload) {
    dispatch.timer.setLoading(true);

    try {
      await timerService.deleteTimer(payload.eventId);
      dispatch.timer.setIsRunning(false);
      dispatch.timer.clearPingTimer();
      dispatch.global.onSuccess(payload);
      dispatch.historyList.getHistory(payload.eventId);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.timer.setLoading(false);
    }
  },
  async updateTimer(payload: ITimerUpdatePayload) {
    dispatch.timer.setLoading(true);

    try {
      await timerService.updateTimer(payload);
      dispatch.timer.getTimer(payload.eventId);
      dispatch.global.onSuccess(payload);
      dispatch.historyList.getHistory(payload.eventId);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.timer.setLoading(false);
    }
  },
});
